var exports = {
  "zr": "xa15a2ab7--40871a--root",
  "kR": "xa15a2ab7--40871a--cards",
  "Nr": "xa15a2ab7--40871a--card",
};

module.exports = exports;
